import { Anchor, Box, Container, Divider, Flex, SimpleGrid, Stack, Text, Title } from '@mantine/core'
import React from 'react'
import { FOOTER_CONTENT } from '../utils/constants'

export default function Footer() {
  const productLinks = FOOTER_CONTENT.links.products
  const solutionLinks = FOOTER_CONTENT.links.solutions
  const companyLinks = FOOTER_CONTENT.links.about

  const FooterSection = ({ title, links }: { title: string; links: { label: string; href: string }[] }) => (
    <Box>
      <Text fw={600} mb={16} c="#fff" size="md" className="md:mb-20 md:text-lg">
        {title}
      </Text>
      <Stack gap={10} className="md:gap-12">
        {links.map((link, index) => (
          <Anchor
            key={index}
            href={link.href}
            c="#9ca3af"
            className="hover:text-blue-300 transition-all duration-300 hover:translate-x-1"
            underline="never"
            size="xs"
          >
            {link.label}
          </Anchor>
        ))}
      </Stack>
    </Box>
  )

  return (
    <Box
      className="relative"
      style={{
        background: 'linear-gradient(to bottom, #1A1F36, #0F172A)',
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      <Box
        className="absolute inset-0 opacity-30"
        style={{
          background:
            'radial-gradient(circle at 15% 50%, rgba(59, 130, 246, 0.15) 0%, transparent 40%), radial-gradient(circle at 85% 30%, rgba(25, 90, 214, 0.1) 0%, transparent 40%)',
        }}
      />

      <Container size="xl" className="relative z-10">
        <Stack py="40px" className="md:py-72px">
          <Flex gap={{ base: 32, md: 64 }} mb={40} wrap="wrap" className="md:mb-60">
            <Box style={{ flex: '1.5', minWidth: '280px' }}>
              <Stack gap={20} className="md:gap-24">
                <Box>
                  <Title
                    order={3}
                    fw={600}
                    size="20px"
                    mb={12}
                    c="#fff"
                    className="tracking-wide md:text-[24px] md:mb-16"
                  >
                    悦享查
                  </Title>
                  <Text mb={8} c="#cbd5e1" size="sm" fw={500}>
                    个人与企业信息查询平台
                  </Text>
                  <Text mb={16} c="#9ca3af" lh={1.7} maw={340} size="xs" className="md:mb-20 md:text-sm">
                    {FOOTER_CONTENT.companyDescription}
                  </Text>
                </Box>
              </Stack>
            </Box>

            <SimpleGrid cols={{ base: 1, sm: 2, md: 3 }} spacing={{ base: 24, md: 48 }} style={{ flex: '2' }}>
              <FooterSection title="查询服务" links={productLinks} />
              <FooterSection title="使用帮助" links={solutionLinks} />
              <FooterSection title="关于我们" links={companyLinks} />
            </SimpleGrid>
          </Flex>

          <Divider color="rgba(255,255,255,0.1)" my={16} className="md:my-20" />

          <Flex justify="space-between" align="center" wrap="wrap" gap={12} className="md:gap-16">
            <Text size="xs" c="#9ca3af" className="md:text-sm">
              {FOOTER_CONTENT.legal.copyright}
            </Text>
            <Flex gap={16} wrap="wrap" className="md:gap-24">
              <Anchor
                size="xs"
                href="https://beian.miit.gov.cn/"
                target="_blank"
                c="#9ca3af"
                underline="never"
                className="hover:text-blue-300 transition-colors duration-300 md:text-sm"
              >
                {FOOTER_CONTENT.legal.icp}
              </Anchor>
              <Anchor
                size="xs"
                href="#"
                c="#9ca3af"
                underline="never"
                className="hover:text-blue-300 transition-colors duration-300 md:text-sm"
              >
                {FOOTER_CONTENT.legal.privacyPolicy}
              </Anchor>
              <Anchor
                size="xs"
                href="#"
                c="#9ca3af"
                underline="never"
                className="hover:text-blue-300 transition-colors duration-300 md:text-sm"
              >
                {FOOTER_CONTENT.legal.termsOfService}
              </Anchor>
              <Anchor
                size="xs"
                href="#"
                c="#9ca3af"
                underline="never"
                className="hover:text-blue-300 transition-colors duration-300 md:text-sm"
              >
                {FOOTER_CONTENT.legal.dataCompliance}
              </Anchor>
            </Flex>
          </Flex>
        </Stack>
      </Container>
    </Box>
  )
}
